import {setURLParams} from 'BenchlingUtil';
import {StructuredTableDict} from 'notebook/documents/DocumentConstants';
import {QueryResolution} from 'notebook/tables/TableStoreTransforms';
import * as net from 'util/Net';

import {StructuredTableKind} from './StructuredTableConstants';

export interface ShadowEvaluationSnapshot {
  documentApiId: string;
  documentName: string;
  versionId: number;
  excessVersion: string;
  queryResolutions: Array<QueryResolution>;
  prevQueryResolutions: Array<QueryResolution>;
}

export interface ShadowEvaluateParams {
  shadowEvaluationSnapshots: Array<ShadowEvaluationSnapshot>;
}

export interface EntryTablesResponse {
  tables: Array<StructuredTableDict>;
}

export interface GetEntryTablesParams {
  entryApiId: string;
  tableKind?: StructuredTableKind;
  schemaId?: string;
  omitRowAndColumnData?: boolean;
}

export function createShadowEvaluationSnapshot(params: ShadowEvaluateParams): JQueryPromise<{}> {
  return net.postJSON({url: `/1/api/eln:create-shadow-evaluation-snapshot`, data: params});
}

export async function getEntryTables(params: GetEntryTablesParams): Promise<EntryTablesResponse> {
  const url = getEntryTableUrl(params);
  const response: EntryTablesResponse = await net.getJSONPromise(url);
  return response;
}

export function getEntryTableUrl(params: GetEntryTablesParams): string {
  return setURLParams(`/1/api/entries/${params.entryApiId}/structured-tables`, {
    table_kind: params.tableKind,
    schema_id: params.schemaId,
    omit_row_and_column_data: params.omitRowAndColumnData,
  });
}
